import React from 'react'

import style from './style.module.css'

export default ({ className, label, ...props }) => (
    <label className={style.checkboxScope}>
        <input
            type='checkbox'
            className={[style.checkbox, className].join(' ')}
            {...props}
        />
        <div />
        {label && (
            <span className={style.content}>
                {label}
            </span>
        )}
    </label>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Form/Checkbox.js